import { DbFolder } from '~src/types/db';

type ListUpdateProps = {
  folders: DbFolder[];
  changedFolderId: DbFolder['id'] | null;
};

export const updateFoldersEmpty = ({
  folders,
  changedFolderId,
}: ListUpdateProps) => {
  const changedFolderIndex = folders.findIndex(
    (item) => item.id === changedFolderId
  );
  if (changedFolderIndex >= 0) {
    const newList = [...folders];
    newList[changedFolderIndex] = {
      ...newList[changedFolderIndex],
      is_empty: false,
    };

    if (newList[changedFolderIndex].parent_id) {
      return updateFoldersEmpty({
        folders: newList,
        changedFolderId: newList[changedFolderIndex].parent_id,
      });
    }

    return newList;
  }

  return folders;
};
